import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import ReactHtmlParser from 'react-html-parser';

import {
  Card,
  Header,
  Saving,
  Pricing,
  Price,
  Label,
  Features,
  Feature,
  Footer,
  Conditions,
} from '../../Shared/PricingCard/styles';

import {
  CurrencySymbol,
  TutoringCardBody,
  TutoringCardDetails,
  TutoringCopy,
  TutoringStandardPrice,
} from './styles';

// * component {}
// * flagValue {string} The value to appear in the saving icon
// * iconGroup {}
// * label {RichText}
// * legal {RichText}
// * price {string} The active price set
// * productDesription {RichText} Conditions required to recieve that price
// * savings {string} the value amount you are saving
// * title {RichText} The title of each card price

const TutoringPricingCard = ({ data }) => {
  if (!data) {
    return null;
  }

  const {
    component,
    currency,
    flagValue,
    iconGroup,
    label,
    legal,
    originalPrice,
    price,
    productDescription,
    savings,
    titleHtml,
  } = data;

  return (
    <Card
      className={[component, flagValue && 'with-flag']}
      flagValue={flagValue}
    >
      <Header>{ReactHtmlParser(titleHtml)}</Header>
      <TutoringCardBody>
        <TutoringCardDetails>
          {savings && <Saving>{savings}</Saving>}
          <Pricing>
            <TutoringStandardPrice>{originalPrice}</TutoringStandardPrice>
            {price && (
              <Price>
                <CurrencySymbol>$</CurrencySymbol>
                {price}
                <span>{currency}</span>
              </Price>
            )}
          </Pricing>
          {productDescription.length > 0 && (
            <Conditions>{RichText.asText(productDescription)}</Conditions>
          )}
        </TutoringCardDetails>
        <TutoringCopy>
          {label && <Label>{RichText.asText(label)}</Label>}
          <Features className="no-bullets">
            {iconGroup.map(({ imageSharp, textHtml }, index) => {
              return (
                <Feature
                  image={imageSharp ? imageSharp.publicURL : null}
                  key={`pricing-card-icons-${index.toString()}`}
                >
                  {ReactHtmlParser(textHtml)}
                </Feature>
              );
            })}
          </Features>
        </TutoringCopy>
        <Footer>
          {legal.length > 0 && (
            <Conditions className="small">{RichText.asText(legal)}</Conditions>
          )}
        </Footer>
      </TutoringCardBody>
    </Card>
  );
};

TutoringPricingCard.propTypes = {
  data: PropTypes.shape().isRequired,
};

TutoringPricingCard.defaultProps = {};

export default TutoringPricingCard;
